import { ReactElement } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { Cancel } from '@mui/icons-material'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ToggleButton, ToggleButtonGroup } from '@ui/actions'
import { useModelStore } from '@editorStores'
import { useResultsSelection } from '@editorHooks'
import GhostModeIcon from 'src/assets/icons/ghostModeIcon.svg?react'

const GhostModeIconComponent = (props: SvgIconProps): ReactElement => {
  return <SvgIcon component={GhostModeIcon} inheritViewBox {...props} />
}

const GhostModeControls = (): ReactElement => {
  const translucent = useModelStore(state => state.translucent)
  const setTranslucent = useModelStore(state => state.setTranslucent)
  const clearTransparencyVisibilityModel = useModelStore(
    state => state.clearTransparencyVisibilityModel,
  )
  const isAnchorCalculationMode = useResultsSelection().activeMode === 'tensile-connectors-table'

  // Shortcut "g" to toggle ghost mode (disabled when typing in anchor table)
  useHotkeys(
    ['g'],
    () => {
      setTranslucent(!translucent)
    },
    { enabled: !isAnchorCalculationMode },
    [translucent, isAnchorCalculationMode],
  )

  // Shortcut "shift + g" to clear ghost mode (disabled when typing in anchor table)
  useHotkeys(
    ['shift+g'],
    () => {
      clearTransparencyVisibilityModel()
      setTranslucent(false)
    },
    { enabled: !isAnchorCalculationMode },
    [isAnchorCalculationMode],
  )

  const handleClearClick = () => {
    clearTransparencyVisibilityModel()
    setTranslucent(false)
  }

  return (
    <ToggleButtonGroup>
      <ToggleButton
        hint="Transparenzmodus"
        onClick={() => setTranslucent(!translucent)}
        selected={translucent}
        Icon={GhostModeIconComponent}
        data-cy="btn-ghost-mode"
      />
      {translucent && (
        <ToggleButton
          hint="Transparenz-Einstellungen zurücksetzen"
          onClick={handleClearClick}
          selected={false}
          Icon={Cancel}
          data-cy="btn-ghost-mode-reset"
        />
      )}
    </ToggleButtonGroup>
  )
}

export default GhostModeControls
